import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
  loading: false,
  items: [],
  total: 0,
  error: null,
};

const route = "modules/manage/views/main/components/workOrderType/redux/slice.";

const manageSearchWorkOrderTypes = createAsyncThunk(
  "manage/workOrderTypes/manageSearchWorkOrderTypes",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchWorkOrderTypes.query,
        {
          conditions,
          sort,
          limit,
          offset,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchWorkOrderTypes");
      return rejectWithValue(exc);
    }
  }
);


manageSearchWorkOrderTypes.query = `
    query ($conditions: [WorkOrderTypeSearchInput], $sort: [WorkOrderTypeSortInput], $limit: Int, $offset: Int) {
        data: searchWorkOrderTypes(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
          total
          items {
            id
            name
            description
            dynamicFormId
            dynamicForm {
                id
                name
            }
            estimatedDurationMins
          }
        }
    }
`;


export { manageSearchWorkOrderTypes }

//Slice
const manageWorkOrderTypesTabRedux = createSlice({
  name: "manage/workOrderType",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchKeyFobs
    builder.addCase(manageSearchWorkOrderTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageSearchWorkOrderTypes.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(manageSearchWorkOrderTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageWorkOrderTypesTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;